import RequestMaster from '../RequestMaster'

export default class RequestClasesParticulares extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/pago-inscripcion/multiple'
    }

    /**
     * Store Multiple
     * 
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    createMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = ""
        this.post(path, params, callback, callbackError, callbackFinally)
    }

}